import React, { useState } from 'react';
import { IIndicadoresCircularizacao, IRegistroCircularizacao } from '../interfaces/ICircularizacao';

interface Props {
  ativos: IRegistroCircularizacao[];
  excluidos: IRegistroCircularizacao[];
  indicadores: IIndicadoresCircularizacao;
  categoriaMarcadaNaoAplicavel: boolean;
}

interface Criterio {
  label: string;
  atendido: boolean;
}

// Seção 11.2 — "Critérios visuais de conclusão": lista preliminar revisada; inclusões e exclusões
// justificadas; cadastros obrigatórios completos; prazos configurados; cartas preparadas;
// categorias não aplicáveis justificadas. Calculado a partir do estado real da tela — não é um
// checklist estático.
const CriteriosConclusaoPanel: React.FC<Props> = ({ ativos, excluidos, indicadores, categoriaMarcadaNaoAplicavel }) => {
  const [expandido, setExpandido] = useState(false);

  if (categoriaMarcadaNaoAplicavel) {
    return null;
  }

  const semDestinatarios = indicadores.empresasAtivas === 0;

  const criterios: Criterio[] = [
    {
      label: 'Lista preliminar revisada',
      atendido: !semDestinatarios && ativos.every((r) => r.situacaoRevisao !== 'PENDENTE'),
    },
    {
      label: 'Inclusões e exclusões justificadas',
      atendido:
        ativos.filter((r) => r.origemSelecao === 'INCLUSAO_MANUAL').every((r) => !!r.justificativaInclusaoManual) &&
        excluidos.every((r) => !!r.justificativaExclusao),
    },
    {
      label: 'Cadastros obrigatórios completos',
      atendido: !semDestinatarios && indicadores.cadastrosCompletos === indicadores.empresasAtivas,
    },
    {
      label: 'Prazos configurados',
      atendido: !semDestinatarios && ativos.every((r) => !!r.dataPrevistaEnvio && !!r.prazoResposta),
    },
    {
      label: 'Cartas preparadas',
      atendido: !semDestinatarios && indicadores.cartasPendentes === 0,
    },
  ];

  const concluidos = criterios.filter((c) => c.atendido).length;
  const tudoConcluido = concluidos === criterios.length;

  return (
    <div className='circ-card mb-3'>
      <button
        type='button'
        className='btn btn-link p-0 d-flex align-items-center gap-2'
        style={{ fontWeight: 700, fontSize: 13.5, color: tudoConcluido ? '#126b3f' : '#1f2a44' }}
        onClick={() => setExpandido((v) => !v)}
      >
        <i className={`bi bi-chevron-${expandido ? 'down' : 'right'}`} style={{ fontSize: 11 }} />
        <i className={`bi ${tudoConcluido ? 'bi-check-circle-fill text-success' : 'bi-list-check'}`} />
        Critérios de Conclusão ({concluidos}/{criterios.length})
      </button>
      {expandido && (
        <ul className='mt-2' style={{ listStyle: 'none', paddingLeft: 24, marginBottom: 0 }}>
          {criterios.map((c) => (
            <li key={c.label} style={{ fontSize: 12.5, marginBottom: 4 }}>
              <i
                className={`bi ${c.atendido ? 'bi-check-circle-fill text-success' : 'bi-circle text-muted'} me-2`}
              />
              {c.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CriteriosConclusaoPanel;
